import {DataTypeDefinitionDto} from "../datatype/DataTypeDefinitionDto";

export interface AttributeDefinitionDto {
    id: string;
    name: string;
    description?: string;
    dataType: DataTypeDefinitionDto;
    required: boolean;
    defaultValue?: string;
    additionalProperties?: AttributePropertiesDto | null;
    acl?: AttributeDefinitionAclDto;
}

export interface AttributeDefinitionAclDto {
    canUpdate: boolean;
    canDelete: boolean;
}

export interface AttributeDefinitionCreateDto {
    name: string;
    description?: string;
    dataTypeId: string;
    required: boolean;
    defaultValue?: string;
    additionalProperties?: AttributePropertiesDto | null;
}

export interface AttributeDefinitionUpdateDto {
    name: string;
    description?: string;
    required: boolean;
    defaultValue?: string;
    additionalProperties?: AttributePropertiesDto | null;
}

export type AttributePropertiesDto =
        | CurrencyAttributePropertiesDto;

export enum AttributePropertiesType {
    CURRENCY = "CurrencyAttributeProperties",
}

export interface CurrencyAttributePropertiesDto {
    type: AttributePropertiesType.CURRENCY;
    currencyCode: string | null;
}
